/* eslint-disable max-len */
import { cloneDeep, uniqBy } from 'lodash'
import { Directive, Input, OnInit } from '@angular/core'
import { NgControl } from '@angular/forms'
import { finalize, tap } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { CsSelectTableComponent } from '../cs-select-table.component'
import { configSelectModel, VssUiConfig } from 'projects/vss-ui/src/public-api'

@Directive({
  selector: 'cs-select-table[csUiSelectDir]'
})
export class CsSelectOptionsCustomDirective implements OnInit{

  /***
   * Example:

   * <cs-select-table [selectOptionsType]="CSSelectOptionType.user" [selectOptionsQueryParams]="{departmentId: departmentId, size: 50}" [(ngModel)]="userId"></cs-select-table>
   */
  count: number = 0
  queryParams: any = {}
  @Input() detailOption!: any[]
  @Input() selectOptionsType?: string
  @Input() pageStart = 1
  @Input() pageSize = 25
  @Input() set selectOptionsQueryParams(value: any | undefined) {
    this.queryParams = {
      page: this.pageStart,
      size: this.pageSize,
      ...value
    }
    this.loadData()
  }
  @Input() isShowIdAndName: boolean = false
  vssUiSelectDirConfig: configSelectModel

  constructor(
    private control: NgControl,
    private viewCsSelect: CsSelectTableComponent,
    vssUiConfig: VssUiConfig
  ) {
    this.vssUiSelectDirConfig = vssUiConfig.configSelectBox || {}
  }

  ngOnInit() {
    this.loadData()
  }

  loadData() {
    this.viewCsSelect.checkDisable = () => false
    if (this.selectOptionsType && this.vssUiSelectDirConfig[this.selectOptionsType]) {
      const configFound = this.vssUiSelectDirConfig[this.selectOptionsType]
      this.viewCsSelect.csIsMultiLevel = configFound.isMultiLevel || this.viewCsSelect.csIsMultiLevel
      this.viewCsSelect.optionList = configFound.optionList || []
      this.viewCsSelect.getOptionsDefaultApi = (valuesSelected: any[]) => {
        if(configFound.getOptionsDefaultApi) {
          return configFound.getOptionsDefaultApi(valuesSelected)
            .pipe(
              tap(res => {
                this.viewCsSelect.selectedValues = res
              }),
              finalize(() => this.viewCsSelect.isLoading = false),
            )
        }
        return of([])
      }
      if(configFound.apiGetOptions) {
        this.viewCsSelect.isLoading = true
        const params = {
          ...cloneDeep(this.viewCsSelect.params || {}),
          ...cloneDeep(this.queryParams),
        }
        if(params.page) delete params.page
        if(params.size) delete params.size
        configFound.apiGetOptions(params).pipe(
          finalize(() => this.viewCsSelect.isLoading = false)
        ).subscribe(
          resp => {
            this.viewCsSelect.isLoading = false
            this.viewCsSelect.getOptionsApi = undefined
            this.viewCsSelect.optionList = resp
            this.viewCsSelect.onSearch('')
          }
        )
      } else {
        this.viewCsSelect.apiStreamSearch = (params: any) : Observable<any[]> => {
          if(configFound?.apiStreamSearch) {
            this.viewCsSelect.isLoading = true
            return configFound?.apiStreamSearch(params).pipe(
              tap( (options) => {
                this.progressTapStreamSearch(options, params, this.pageStart)
              }),
              finalize(() => this.viewCsSelect.isLoading = false),
            )
          }
          return of([])
        }
        this.viewCsSelect.getOptionsApi = () => new Promise<any[]>(() => {})
        this.viewCsSelect.onSearch('')
      }

    }
  }

  handlerDetailOptions() {
    const data = this.detailOption.map((x:any) => ({ value: x.id , label:`${x.title }`, ...x }))
    if(data?.[0]?.value) {
      this.viewCsSelect.optionList = uniqBy([...this.viewCsSelect.optionList, ...data], 'id').filter(Boolean)
      this.viewCsSelect.options = uniqBy([...this.viewCsSelect.options, ...data], 'id').filter(Boolean)
    }
  }

  progressTapStreamSearch(options: any[], params: any, pageStart = 1) {
    if(params.page == pageStart) {
      this.viewCsSelect.optionList = options
      this.viewCsSelect.options = options
    }else {
      this.viewCsSelect.optionList = this.viewCsSelect.optionList.concat(options)
      this.viewCsSelect.options = this.viewCsSelect.optionList.concat(options)
    }
    if(this.detailOption && this.detailOption?.length) {
      this.handlerDetailOptions()
    }
  }
}
